var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"move",attrs:{"slot":"header"},slot:"header"},[_c('h3',[_vm._v("Closed Applications")])]),_vm._v(" "),_c('div',{staticClass:"mt-4 text-center"},[_c('span',{staticClass:"card-value"},[_c('h2',[_vm._v(_vm._s(_vm.value.length ? _vm.value : 0))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }